/* eslint-disable @typescript-eslint/no-explicit-any */
/** Avoid running the same function twice within the specified timeframe. */
export const debounce = (
    func: (...args) => unknown,
    wait: number,
    immediate: boolean = false
) => {
    let timeout: any;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            timeout = null;
            if (!immediate) func(args);
        }, wait);
        if (immediate && !timeout) func(args);
    };
};
